var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37473 4.98054C2.30204 5.7697 2.25102 7.16631 2.70886 7.76077C2.70886 7.76077 2.49333 6.22658 4.42541 4.30171C5.20335 3.52682 5.38316 2.47288 5.11153 1.68242C4.95721 1.23463 4.67537 0.864707 4.43051 0.606413C4.28768 0.454552 4.39736 0.204045 4.60523 0.213131C5.86268 0.270241 7.90061 0.625882 8.76654 2.83761C9.14658 3.80848 9.17463 4.81181 8.99354 5.832C8.87877 6.48358 8.47067 7.9321 9.40164 8.10992C10.0661 8.23712 10.3874 7.69977 10.5316 7.31298C10.5915 7.15203 10.7994 7.11179 10.9116 7.24029C12.0339 8.53955 12.1295 10.0698 11.8974 11.3873C11.4485 13.9339 8.91447 15.7874 6.39703 15.7874C3.25214 15.7874 0.748719 13.9559 0.0995903 10.6409C-0.161846 9.30275 -0.0292149 6.65491 1.99851 4.78585C2.149 4.64567 2.39513 4.77027 2.37473 4.98054Z",
    fill: "url(#paint0_radial_24969_264208)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45104 9.6004C6.3086 8.06161 6.82012 6.30581 7.10039 5.60612C7.1381 5.51405 7.03755 5.42725 6.95837 5.4838C6.46696 5.83365 5.46026 6.65697 4.99147 7.81567C4.35678 9.38208 4.40202 10.1488 4.77781 11.0853C5.00403 11.6495 4.74136 11.7692 4.6094 11.7902C4.4812 11.8113 4.36306 11.7218 4.2688 11.6285C3.99763 11.356 3.80439 11.0099 3.71078 10.6289C3.69067 10.5474 3.58887 10.525 3.54237 10.5921C3.19046 11.1011 3.00822 11.9178 2.99942 12.4952C2.97177 14.2799 4.38066 15.7266 6.08489 15.7266C8.23278 15.7266 9.79751 13.2409 8.56332 11.1629C8.20513 10.5579 7.8683 10.162 7.45104 9.6004Z",
    fill: "url(#paint1_radial_24969_264208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_24969_264208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.77414 15.8277) rotate(-179.747) scale(9.00206 15.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24969_264208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.20302 6.52786) rotate(90.553) scale(9.71361 6.98569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.9a8a3662610bfb565a109ca5277ab4c5.svg";
export { ForwardRef as ReactComponent };